import { createFileRoute } from '@tanstack/react-router';
import InvoiceDetail from '@/pages/InvoiceDetail';

export const Route = createFileRoute('/_authenticated/invoices/$invoiceId')({
  component: InvoiceDetail,
});
